import axios from "axios";
var interceptors = {
  request: [],
  response: []
};

var init = function init(callback) {
  callback(axios);
};

var setJwt = function setJwt(jwt) {
  axios.defaults.headers.common.Authorization = "JWT ".concat(jwt);
};

var setCustomHeader = function setCustomHeader(header, value) {
  axios.defaults.headers.common[header] = value;
}; // beforeRequestInterceptor: if you need to modify request before initiating it
// NOTE: should return the request
// onRequestRejected: when a request is rejected your receive error.


var addRequestInterceptor = function addRequestInterceptor(_ref) {
  var interceptorName = _ref.interceptorName,
      beforeRequestInterceptor = _ref.beforeRequestInterceptor,
      onRequestRejected = _ref.onRequestRejected;
  var interceptorId = axios.interceptors.request.use(beforeRequestInterceptor, onRequestRejected);
  interceptors.request.push({
    interceptorName: interceptorName,
    interceptorId: interceptorId
  });
  return interceptorId;
}; // interceptor: should be an instance of the interceptor 'returned on creation'


var removeRequestInterceptor = function removeRequestInterceptor(interceptorId) {
  if (interceptors.request.find(function (interceptor) {
    return interceptor.interceptorId === interceptorId;
  })) {
    interceptors.request = interceptors.request.filter(function (interceptor) {
      return interceptorId !== interceptor.interceptorId;
    });
    axios.interceptors.request.eject(interceptorId);
  }
}; // successInterceptor: to intercept responses in range 2xx.
// errorInterceptor: to intercept anything that's not in range 2xx responses.


var addResponseInterceptor = function addResponseInterceptor(_ref2) {
  var interceptorName = _ref2.interceptorName,
      successInterceptor = _ref2.successInterceptor,
      errorInterceptor = _ref2.errorInterceptor;
  var interceptorId = axios.interceptors.response.use(successInterceptor, errorInterceptor);
  interceptors.response.push({
    interceptorName: interceptorName,
    interceptorId: interceptorId
  });
  return interceptorId;
}; // interceptor: should be an instance of the interceptor 'returned on creation'


var removeResponseInterceptor = function removeResponseInterceptor(interceptorId) {
  if (interceptors.response.find(function (interceptor) {
    return interceptor.interceptorId === interceptorId;
  })) {
    interceptors.response = interceptors.response.filter(function (interceptor) {
      return interceptorId !== interceptor.interceptorId;
    });
    axios.interceptors.response.eject(interceptorId);
  }
};

export default {
  request: axios.request,
  get: axios.get,
  post: axios.post,
  put: axios.put,
  patch: axios.patch,
  "delete": axios["delete"],
  setJwt: setJwt,
  init: init,
  addRequestInterceptor: addRequestInterceptor,
  removeRequestInterceptor: removeRequestInterceptor,
  addResponseInterceptor: addResponseInterceptor,
  removeResponseInterceptor: removeResponseInterceptor,
  interceptors: interceptors,
  setCustomHeader: setCustomHeader
};